<template lang="pug">
div
  iframe(
    onload='window.parent.scrollTo(0,0)'
    :src='url'
    frameborder='0'
    scrolling='no'
    allow='fullscreen; clipboard-write'
    class='min-h-screen w-screen border-0'
  )
</template>

<script setup lang="ts">
const fitmentStore = useFitmentStore()
const fitmentDisplayStore = useFitmentDisplayStore()
const { translateTemplate } = useTemplateTranslator()

const url = computed(() => {
  let url = 'https://realtruck.oneprotex.com/builder/'
  // We must have full fitment
  if (!fitmentDisplayStore.hasFullFitment) return url

  // Build our Query Params
  if (fitmentStore.makeSlug) url += `?make=${fitmentStore.makeSlug}`
  if (fitmentStore.modelSlug) url += `&model=${fitmentStore.modelSlug}`
  if (fitmentStore.year) url += `&year=${fitmentStore.year}`
  if (fitmentStore.bedSlug) url += `&bed=${fitmentStore.bedSlug}`
  if (fitmentStore.bodySlug) url += `&body=${fitmentStore.bodySlug}`
  // http://realtruck.oneprotex.com/builder/?make=ford&model=f150&year=2023&bed=6-7-bed&body=supercrew
  // http://realtruck.oneprotex.com/builder/?make=ford&model=f150&year=2023&bed=5-7-bed
  return url
})

definePageMeta({
  layout: 'blank',
})

useMetaTags({
  title: translateTemplate('Protex [TITLE_SUFFIX]'),
  isNoIndex: true,
})
</script>
